import script from "./ConfigureProviderStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigureProviderStep.vue?vue&type=script&setup=true&lang=js"

import "./ConfigureProviderStep.vue?vue&type=style&index=0&id=4c6e78a7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6e78a7"]])

export default __exports__